<app-dialog-heading [heading]="heading"></app-dialog-heading>
<p class="validationError" [innerHTML]="getGlobalValidationError()"></p>
<div class="dialog-content">
  <form [formGroup]="applicationForm">
    <div class="clearfix">
      <div class="col col-6 mb1">
        <greydom-element-input label="Application Reference Number"
                               [required]="true"
                               [formControlName]="controls.ApplicationReferenceNumber"

                               [markAsDirtyOnEdit]="true">
        </greydom-element-input>
      </div>
      <div class="col col-6 mb1">
        <app-element-input
          label="Contact Number"
          placeholder="e.g. 0821234567"
          [required]="true"
          [formControlName]="controls.ContactNumber"
          [customValidators]="getContactNumberValidators()"
          [customErrorMessages]="customValidatorsList"
          [markAsDirtyOnEdit]="true">
        </app-element-input>
      </div>
    </div>
    <div class="clearfix">
      <div class="col col-6 mb1">
        <mat-form-field>
          <mat-label>Relationship</mat-label>
          <mat-select [formControlName]="controls.Relationship" required>
            <mat-option *ngFor="let item of relationshipTypes" [value]="getFormValue(item)">
              {{getDisplayValue(item)}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="shouldShowError(controls.Relationship)">
            This field is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col col-6 mb1">
        <app-element-input
          label="Email Address"
          placeholder="e.g. johndoe@gmail.com"
          [required]="true"
          [formControlName]="controls.EmailAddress"
          [customValidators]="getEmailValidators()"
          [customErrorMessages]="customValidatorsList"
          [markAsDirtyOnEdit]="true">
        </app-element-input>
      </div>
    </div>
    <div class="clearfix">
      <div class="col col-6 mb1">
        <mat-form-field>
          <mat-label>Title</mat-label>
          <mat-select [formControlName]="controls.Title" required>
            <mat-option *ngFor="let item of titles" [value]="getFormValue(item)">
              {{getDisplayValue(item)}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="shouldShowError(controls.Title)">
            This field is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col col-6 mb1">
        <mat-form-field>
          <mat-label>Bank</mat-label>
          <mat-select [formControlName]="controls.BankName" [required]="isPrincipalMember()">
            <mat-option *ngFor="let item of bankOptions" [value]="getFormValue(item)">
              {{getDisplayValue(item)}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="shouldShowError(controls.BankName)">
            This field is required
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="clearfix">
      <div class="col col-6 mb1">
        <greydom-element-input label="Name"
                               [formControlName]="controls.Name"
                               [required]="true"
                               [markAsDirtyOnEdit]="true"
                               >
        </greydom-element-input>
      </div>
      <div class="col col-6 mb1">
        <greydom-element-input
          label="Account Number"
          [required]="isPrincipalMember()"
          [customErrorMessages]="customValidatorsList"
          [customValidators]="getAccountNumberValidators()"
          [formControlName]="controls.AccountNumber"
          [markAsDirtyOnEdit]="true">
        </greydom-element-input>
      </div>
    </div>
    <div class="clearfix">
      <div class="col col-6 mb1">
        <greydom-element-input label="Surname"
                               [formControlName]="controls.Surname"
                               [required]="true"
                               [markAsDirtyOnEdit]="true">
        </greydom-element-input>
      </div>
      <div class="col col-6 mb1">
        <mat-form-field>
          <mat-label>Account Type</mat-label>
          <mat-select [formControlName]="controls.AccountType" [required]="isPrincipalMember()">
            <mat-option *ngFor="let item of accountTypes" [value]="getFormValue(item)">
              {{getDisplayValue(item)}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="shouldShowError(controls.AccountType)">
            This field is required
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="clearfix">
      <div class="col col-6 mb1">
        <mat-form-field>
          <mat-label>ID Type</mat-label>
          <mat-select [formControlName]="controls.IdType" required>
            <mat-option *ngFor="let item of idTypes" [value]="getFormValue(item)">
              {{getDisplayValue(item)}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="shouldShowError(controls.IdType)">
            This field is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col col-6 mb1">
        <mat-form-field>
          <mat-label>Address Type</mat-label>
          <mat-select [formControlName]="controls.AddressType" required>
            <mat-option *ngFor="let item of addressTypes" [value]="getFormValue(item)">
              {{getDisplayValue(item)}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="shouldShowError(controls.AddressType)">
            This field is required
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="clearfix">
      <div class="col col-6 mb1">
        <ng-container *ngIf="isSIDTypeSelected()">
          <app-element-input
            label="ID Number"
            [required]="true"
            [customValidators]="getSIDValidators()"
            [formControlName]="controls.IdNumber"
            [customErrorMessages]="idNumberErrorMessage"
            [markAsDirtyOnEdit]="true">
          </app-element-input>
        </ng-container>

        <ng-container *ngIf="isPassportTypeSelected()">
          <app-element-input
            label="Passport Number"
            [required]="true"
            [minLength]="6"
            [maxLength]="20"
            [formControlName]="controls.IdNumber"
            [customValidators]="getPassportValidators()"
            [markAsDirtyOnEdit]="true">
          </app-element-input>
        </ng-container>
      </div>
      <div class="col col-6 mb1">
        <app-element-input
          label="Address Number"
          [required]="true"
          [formControlName]="controls.AddressNumber"
          [customValidators]="getAddressNumberValidators()"
          [customErrorMessages]="customValidatorsList"
          [markAsDirtyOnEdit]="true">
        </app-element-input>
      </div>
    </div>
    <div class="clearfix">
      <div class="col col-6 mb1">
        <greydom-date-picker
          label="Date of Birth"
          [required]="true"
          [showInfoIcon]="false"
          [markAsDirtyOnEdit]="true"
          [formControlName]="controls.DateOfBirth">
        </greydom-date-picker>
      </div>
      <div class="col col-6 mb1">
        <greydom-element-input label="Address Name"
                               [formControlName]="controls.AddressName"
                               [required]="true"
                               [markAsDirtyOnEdit]="true">
        </greydom-element-input>
      </div>
    </div>
    <div class="clearfix">
      <div class="col col-6 mb1">
        <mat-form-field>
          <mat-label>Gender</mat-label>
          <mat-select [formControlName]="controls.Gender" required>
            <mat-option *ngFor="let item of genders" [value]="getFormValue(item)">
              {{getDisplayValue(item)}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="shouldShowError(controls.Gender)">
            This field is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col col-6 mb1">
        <greydom-element-input label="Address Suburb"
                               [formControlName]="controls.AddressSuburb"
                               [required]="true"
                               [markAsDirtyOnEdit]="true">
        </greydom-element-input>
      </div>
    </div>
    <div class="clearfix">
      <div class="col col-6 mb1">
        <mat-form-field>
          <mat-label>Marital Status</mat-label>
          <mat-select [formControlName]="controls.MaritalStatus" required>
            <mat-option *ngFor="let item of maritalStatuses" [value]="getFormValue(item)">
              {{getDisplayValue(item)}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="shouldShowError(controls.MaritalStatus)">
            This field is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col col-6 mb1">
        <mat-form-field>
          <mat-label>Ethnicity</mat-label>
          <mat-select [formControlName]="controls.Ethnicity" required>
            <mat-option *ngFor="let item of ethnicities" [value]="getFormValue(item)">
              {{getDisplayValue(item)}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="shouldShowError(controls.Ethnicity)">
            This field is required
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="clearfix">
      <div class="col col-6 mb1">
        <greydom-element-input label="Employee Number"
                               [formControlName]="controls.EmployeeNumber"
                               [required]="isPrincipalMember() && !isDirectPayingMember()"
                               [customValidators]="getEmployeeNumberValidators()"
                               [markAsDirtyOnEdit]="true">
        </greydom-element-input>
      </div>
      <div class="col col-6 mb1">
        <greydom-date-picker label="Employment Date"
                             [required]="isPrincipalMember() && !isDirectPayingMember()"
                             [showInfoIcon]="false"
                             [markAsDirtyOnEdit]="true"
                             [formControlName]="controls.EmploymentDate">
        </greydom-date-picker>
      </div>
    </div>

    <div class="clearfix">
      <div class="col col-6 mb1">
        <mat-form-field>
          <mat-label>Option</mat-label>
          <mat-select [formControlName]="controls.Option" [required]="isPrincipalMember()">
            <mat-option *ngFor="let item of options" [value]="getFormValue(item)">
              {{getDisplayValue(item)}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="shouldShowError(controls.Option)">
            This field is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col col-6 mb1" *ngIf="isBcapOption()">
        <mat-form-field>
          <mat-label>Income Amount</mat-label>
          <input matInput
                 [required]="isPrincipalMember()"
                 [formControlName]="controls.IncomeAmount"
                 (blur)="onBlurIncomeAmount()">
        </mat-form-field>
      </div>
    </div>
  </form>
</div>

<mat-dialog-actions align="center" class="dialog-button-container">
  <button mat-raised-button color="warn" (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" [disabled]="!applicationForm.valid" (click)="onSave()">Save</button>
</mat-dialog-actions>
